import { Box } from '@mui/material'
import { memo } from 'react'
import type { TabKanbanActual, TabKanbanRecommendation } from './MaterialItem'
import MaterialItem from './MaterialItem'
import PalletItem from './PalletItem'
import type { Kanban, Material } from './types'

interface ListMaterialProps {
  materials: Material[]
  onQuantityAdjust?: (kanban: Kanban) => void
  onScanKanban?: (kanban: Kanban) => void
  onScanPallet?: (pallet: { name: string; code: string; qrCodeImage?: string }) => void
  actionPosition?: 'left' | 'right'
  variant?: 'material' | 'pallet'
  viewOnly?: boolean
  hideCode?: boolean

  // Props untuk mode withTabs (DO_READY_TO_SHOPPING / PO_SHOPPING)
  withTabs?: boolean
  getTabRecommendationKanbans?: (materialId: string) => TabKanbanRecommendation[]
  getTabActualKanbans?: (materialId: string) => TabKanbanActual[]
  onScanRecommendationKanban?: (materialId: string, item: TabKanbanRecommendation) => void
  onAdjustActualTaken?: (materialId: string, entry: TabKanbanActual) => void
  onDeleteActualKanban?: (materialId: string, kanbanCode: string) => void
}

const ListMaterial = memo<ListMaterialProps>(
  ({
    materials,
    onQuantityAdjust,
    onScanKanban,
    onScanPallet,
    actionPosition = 'right',
    variant = 'material',
    viewOnly = false,
    hideCode = false,
    withTabs = false,
    getTabRecommendationKanbans,
    getTabActualKanbans,
    onScanRecommendationKanban,
    onAdjustActualTaken,
    onDeleteActualKanban
  }) => (
    <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {materials.map((material, index) =>
        variant === 'pallet' ? (
          <PalletItem
            key={`${material.code}-${index}`}
            {...material}
            actionPosition={actionPosition}
            viewOnly={viewOnly}
            onQuantityAdjust={onQuantityAdjust}
            onScanKanban={onScanKanban}
            onScanPallet={onScanPallet}
          />
        ) : (
          <MaterialItem
            key={`${material.code}-${index}`}
            {...material}
            actionPosition={actionPosition}
            viewOnly={viewOnly}
            onQuantityAdjust={onQuantityAdjust}
            onScanKanban={onScanKanban}
            hideCode={hideCode}
            withTabs={withTabs}
            tabRecommendationKanbans={
              withTabs && (material.materialMasterId ?? material.id)
                ? (getTabRecommendationKanbans?.(material.materialMasterId ?? material.id!) ?? [])
                : []
            }
            tabActualKanbans={
              withTabs && (material.materialMasterId ?? material.id)
                ? (getTabActualKanbans?.(material.materialMasterId ?? material.id!) ?? [])
                : []
            }
            onScanRecommendationKanban={
              withTabs && (material.materialMasterId ?? material.id)
                ? item => onScanRecommendationKanban?.(material.materialMasterId ?? material.id!, item)
                : undefined
            }
            onAdjustActualTaken={
              withTabs && (material.materialMasterId ?? material.id)
                ? entry => onAdjustActualTaken?.(material.materialMasterId ?? material.id!, entry)
                : undefined
            }
            onDeleteActualKanban={
              withTabs && (material.materialMasterId ?? material.id)
                ? code => onDeleteActualKanban?.(material.materialMasterId ?? material.id!, code)
                : undefined
            }
          />
        )
      )}
    </Box>
  )
)

export default ListMaterial
